import React from 'react';
import StandardButton from '@/components/ui/Buttons/StandardButton';
import cn from '@/utils/cn';

type ButtonProps = {
  label: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const TextVariableButton = ({ label, onClick } : ButtonProps) => (
  <StandardButton
    className={cn('tw-w-full tw-text-start tw-bg-white hover:tw-bg-light-grey tw-border-none tw-text-black',
      'hover:tw-text-black !tw-shadow-none')}
    type="button"
    onMouseDown={onClick}
  >
    <p className="tw-m-0">{label}</p>
  </StandardButton>
);

export default TextVariableButton;
